var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"p-0 bg-white border-0"},[_c('img',{staticClass:"cursor-pointer",attrs:{"src":require("@/assets/images/close.svg"),"alt":"close"},on:{"click":_vm.clicked}})])}
var staticRenderFns = []

export { render, staticRenderFns }